import { inject, InjectionToken, Type } from '@angular/core';

import { cosProvide } from '@cosmos/core';
import type { BaseStorageService } from '@cosmos/data-access-storage';

export const STATS_BATCHES_STORAGE_KEY = 'devtools-stats-batches';
export const STATS_COLLECTOR_STORAGE = new InjectionToken<BaseStorageService>(
  ''
);

export function provideStatsCollectorStorage(
  storageImplementation: Type<BaseStorageService>
) {
  return cosProvide({
    provide: STATS_COLLECTOR_STORAGE,
    useExisting: storageImplementation,
  });
}

export function injectStatsCollectorStorage(): BaseStorageService | null {
  return inject(STATS_COLLECTOR_STORAGE, { optional: true });
}
